import { lazy } from "react"
const Profile = lazy(() => import('../talentProfile/talent-profile'))
const TalentFeedbackPage = lazy(() => import('../feedback/TalentFeedbackPage'));
const HoursReporting = lazy(() => import('../timeTracking/HoursReportingPage'));
const TalentMonthlyInvoices = lazy(() => import('../monthlyInvoices/TalentMonthlyInvoices'));
const AccountSettings = lazy(() => import('../account/AccountSettings'));
const TalentManual = lazy(() => import('../manual/TalentManual'));

const routes = [
  {
    path: '/manual',
    Component: TalentManual,
    name: 'TalentManual'
  },
  {
    path: '/profile',
    Component: Profile,
    name: '/talent/profile'
  },
  {
    path: '/feedback',
    Component: TalentFeedbackPage,
    name: 'Fb modal'
  },
  {
    path: '/my-finance',
    Component: TalentMonthlyInvoices,
    name: 'MyFinance'
  },
  {
    path: '/monthly-invoices',
    Component: TalentMonthlyInvoices,
    name: 'TalentMonthlyInvoicesLegacy'
  },
  {
    path: '/hours-reporting',
    Component: HoursReporting,
    name: 'HoursReporting'
  },
  {
    path: '/account',
    Component: AccountSettings,
    name: 'AccountSettings'
  }
]
export default routes
